
export {default as hostComponent} from './host-component.js';
export {default as isbn} from './isbn.js';
export {default as issn} from './issn.js';
export {default as publisherNumber} from './publisherNumber.js'; // 028$b$a
export {default as sid} from './sid.js';
export {default as otherStandardIdentifier} from './other-standard-identifier.js';
export {default as title} from './title.js';
export {default as authors} from './authors.js';
export {default as recordType} from './record-type.js';
export {default as publicationTime} from './publication-time.js';
export {default as publicationTimeAllowConsYears} from './publication-time-allow-cons-years.js';
export {default as publicationTimeAllowConsYearsMulti} from './publication-time-allow-cons-years-multi.js';
export {default as language} from './language.js';
export {default as bibliographicLevel} from './bibliographic-level.js';
export {default as melindaId} from './melinda-id.js';
export {default as allSourceIds} from './all-source-ids.js';
export {default as mediaType} from './media-type.js';
export {default as f773} from './f773.js';
